/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface ZocdocInsurancePlan {
  plan_id: string;
  plan_name: string;
  network_type: string;
  carrier_name: string;
}
